export const computeOptions = [
  {
    text: "0.25 CPU / 0.5 GB RAM",
    CPU: "256",
    RAM: "512",
  },
  {
    text: "0.25 CPU / 1 GB RAM",
    CPU: "256",
    RAM: "1024",
  },
  {
    text: "0.25 CPU / 2 GB RAM",
    CPU: "256",
    RAM: "2048",
  },
  {
    text: "0.5 CPU / 1 GB RAM",
    CPU: "512",
    RAM: "1024",
  },
  {
    text: "0.5 CPU / 2 GB RAM",
    CPU: "512",
    RAM: "2048",
  },
  {
    text: "0.5 CPU / 4 GB RAM",
    CPU: "512",
    RAM: "4096",
  },
  {
    text: "1 CPU / 2 GB RAM",
    CPU: "1024",
    RAM: "2048",
  },
  {
    text: "1 CPU / 4 GB RAM",
    CPU: "1024",
    RAM: "4096",
  },
  {
    text: "1 CPU / 8 GB RAM",
    CPU: "1024",
    RAM: "8192",
  },
];

export const deploymentTimeOutOptions = [
  {
    text: "1 minute",
    value: "60",
  },
  {
    text: "2 minutes",
    value: "120",
  },
  {
    text: "3 minutes",
    value: "180",
  },
  {
    text: "5 minutes",
    value: "300",
  },
  {
    text: "10 minutes",
    value: "600",
  },
  {
    text: "15 minutes",
    value: "900",
  },
  {
    text: "20 minutes",
    value: "1200",
  },
  {
    text: "30 minutes",
    value: "1800",
  },
];

export const defaultTimeOutValue = "300";
